/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

"use client";

import React, { createContext, useContext, useEffect, useState } from "react";
import {
  subscribeRateLimit,
  type RateLimitState,
} from "@/lib/api/rate-limit-events";

interface RateLimitContextValue {
  state: RateLimitState | null;
}

const RateLimitContext = createContext<RateLimitContextValue | undefined>(
  undefined,
);

export const RateLimitProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [state, setState] = useState<RateLimitState | null>(null);
  useEffect(() => subscribeRateLimit(setState), []);
  return (
    <RateLimitContext.Provider value={{ state }}>
      {children}
    </RateLimitContext.Provider>
  );
};

export function useRateLimit(): RateLimitContextValue {
  const ctx = useContext(RateLimitContext);
  if (!ctx) return { state: null };
  return ctx;
}
